import * as RouteNames from "@/employee/route-names";
import { CustodianStatementLink } from "@/shared/types";

export const taxLink: CustodianStatementLink = {
    url: "/resources/tax-forms",
    target: "_self"
  };

  export const statementsLink = taxLink;

export const footerTemplate = "HsaBankInvestmentsFooter";

export const investmentRiskDisclaimer = null;

export const profileEditInformationHtml = "";

export const displayMyProfileEditMode = false;

export const loginUrl = "https://user.bendhsa.com/#/hsab-login";

export const logoutRedirectUrl = null;

export const faqTemplate = "HsaBankForms";

export const faqInstructionsTemplate = "";

export const faqLinkAddress = "";

export const displayFaqInstructions = false;

export const displayAdvice = true;

export const displayFaqExternalLinks = false;

export const displayInvestmentsSection = true;

export const displaySettingsLinkedAccounts = true;

export const allowEmailEdit = false;

export const priorYearContributionOption = true;

export const allowReimbursement = false;

export const showPendingReimbursements = false;

export const transactionPayrollOneTimeIsAdjustment = true;

export const showAlternateOnboardingCompleteMessage = true;

export const disabledRouteRedirects = {
  [RouteNames.HealthcareExpenses]: RouteNames.CashBalance,
  [RouteNames.HealthcareExpenseClaims]: RouteNames.CashBalance,
  [RouteNames.HealthcareExpensesUnreimbursed]: RouteNames.CashBalance,
  [RouteNames.HealthcareExpensesReimbursed]: RouteNames.CashBalance,
  [RouteNames.HealthcareExpensesUnreviewed]: RouteNames.CashBalance,
  [RouteNames.EligibleExpenses]: RouteNames.CashBalance,
  [RouteNames.FindExpenses]: RouteNames.CashBalance,
  [RouteNames.ViewClaims]: RouteNames.CashBalance
};

export const displayCashAccountMfaPopup = true;

export const termsUrl = "/hsab_ioe_ESIGN _OLSA _Nov2021.pdf";
export const hsaTermsUrl = "/HSA_Agreement_031826.pdf";

export const feeTemplate = "HsaBankFeeScheduleAndInterestRatesInfo";

export const quarterlyPaperStatementFee = 1.5;

export const manageHsaCardsInPortal = true;

export const displayPriorYearContributionDisclaimerCopy = false;

export const displayProjectedContributions = false;

export const allowUserToEditContributions = false;

export const showCashExpensesGraphWidget = false;
export const showExpenseCategoryWidget = false;
export const showExpenseEligibilityWidget = false;
export const showHealthcareExpensesV2 = false;
export const showHsaStoreShopTab = true;

export const displayHealthcareClaims = false;
export const displayPdfForESign = false;

export const displayHealthcareBluebookLink = true;

export const displayFooterLegalSection = false;

export const contactDetailsSetAtBank = false;

export const showChildExpenseRows = false;

export const disableHsaInvestEnrollButtonAfterDate = false;

export const disablePortalFunctionalityAfterDate = false;

export const displayFdicBanner = true;

export const fdicDisclaimer = "For deposit accounts offered by HSA Bank, a division of Webster Bank, N.A.";

export const allowFamilyMemberSsnInput = true;

export const transferOrRolloverHsaFundsUrl = "https://hsabank.com/Members/Transfer-Rollover-HSA-Funds.html";

export const loginHelpUrl = "https://hsabank.com/HSABank/Learning-Center/Help-center/Member-Login-Help";